import dayjs from "dayjs";

const format: (time: number) => string = (time: number) => {
    return dayjs(time).format("YYYY-MM-DD HH:mm:ss (Z[Z])")
}

const time = { format }

export default time